import { Component, Input, IterableDiffers, DoCheck, Output, EventEmitter } from '@angular/core';

import * as L from 'leaflet';

import geoData from "src/assets/data/countries_GeoJSON.json";

import { Layer } from 'node_modules/@types/leaflet/index.d';
import * as geojson from 'geojson';

import { LeafletBlockComponent } from '../leaflet-block-component.interface';

@Component({
    selector: 'leaflet-geo-json-layer',
    template: '',
    standalone: false
})
export class LeafletGeoJsonLayerComponent implements LeafletBlockComponent, DoCheck {

	@Input() public name: string;
	@Input() public isDefault: boolean = true;
	@Input() public includeInOverlays: boolean = true;

	private _geoStyle: L.PathOptions | L.StyleFunction<any> | undefined;
	@Input()
	public get geoStyle() { return this._geoStyle; }
	public set geoStyle(value: L.PathOptions | L.StyleFunction<any> | undefined) {
		this._geoStyle = value;

		this.updateLayerGroup();
	}

	@Output() public onEachFeature: EventEmitter<{ feature: geojson.Feature<geojson.GeometryObject, any>, layer: Layer }> = new EventEmitter<{ feature: geojson.Feature<geojson.GeometryObject, any>, layer: Layer }>();

	private _map: L.Map;
  private _layerGroup: L.LayerGroup<any>;

	public updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
			this._layerGroup.removeFrom(this._map);
		}

		this._layerGroup = L.geoJSON(
			<geojson.GeoJsonObject>geoData,
			{
				onEachFeature: (feature: geojson.Feature<geojson.GeometryObject, any>, layer: Layer) => {
					this.onEachFeature.emit(
						{
							feature: feature,
							layer: layer
						}
					)
				},
				style: this._geoStyle
			}
		);

		this._layerGroup.addTo(this._map);
	}

	public initialize(layerGroup: L.LayerGroup, map: L.Map): void {
		this._layerGroup = layerGroup;
		this._map = map;

		this.updateLayerGroup();
	}

	private iterableDiffer: any;

	constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
	}

	ngDoCheck(): void {
	
	}
}
